/* Maison Poster — personnaliseur de posters (aperçu en direct + fichier d'impression HD) */
(function () {
  'use strict';

  var PT = 0.3528;          // mm par point
  var BLEED = 4;            // fond perdu Gelato (mm)
  var MAX_PIXELS = 16e6;    // limite sûre pour les canvas mobiles
  var THEMES = {
    ivoire: { paper: '#F3EEE6', ink: '#2B2724', accent: '#9C7E52', ph: '#E6DDD0' },
    sauge:  { paper: '#DCE2D4', ink: '#27312A', accent: '#66775A', ph: '#CBD3C1' },
    nuit:   { paper: '#1E2833', ink: '#F2ECDF', accent: '#C7A66C', ph: '#2B3845' }
  };
  var FONT_STYLES = {
    serif:          { family: 'PCormorant', weight: 500, style: 'normal', label: 'Élégante' },
    'serif-italic': { family: 'PCormorant', weight: 500, style: 'italic', label: 'Élégante italique' },
    sans:           { family: 'PJost', weight: 400, style: 'normal', label: 'Moderne' },
    caps:           { family: 'PJost', weight: 500, style: 'normal', label: 'MAJUSCULES', upper: true, track: 0.28 },
    script:         { family: 'PScript', weight: 400, style: 'normal', label: 'Manuscrite' }
  };
  var SEP = '  ·  ';

  /* ---------- utilitaires ---------- */
  function fontCss(f, sizeMm) { return f.style + ' ' + f.weight + ' ' + sizeMm + 'px ' + f.family + ', Georgia, serif'; }
  var F = {
    serif:   { family: 'PCormorant', weight: 500, style: 'normal' },
    serifSB: { family: 'PCormorant', weight: 600, style: 'normal' },
    serifIt: { family: 'PCormorant', weight: 500, style: 'italic' },
    sans:    { family: 'PJost', weight: 400, style: 'normal' },
    sansMd:  { family: 'PJost', weight: 500, style: 'normal' }
  };

  function textWidth(ctx, txt, f, size, track) {
    ctx.font = fontCss(f, size);
    if (!track) return ctx.measureText(txt).width;
    var w = 0;
    for (var i = 0; i < txt.length; i++) w += ctx.measureText(txt[i]).width;
    return w + track * size * (txt.length - 1);
  }

  function drawText(ctx, txt, f, size, cx, y, color, track, maxW) {
    if (!txt) return size;
    if (maxW) { while (textWidth(ctx, txt, f, size, track) > maxW && size > 2) size -= 0.1; }
    var w = textWidth(ctx, txt, f, size, track);
    ctx.font = fontCss(f, size);
    ctx.fillStyle = color;
    ctx.textBaseline = 'alphabetic';
    ctx.textAlign = 'left';
    if (!track) { ctx.fillText(txt, cx - w / 2, y); return size; }
    var x = cx - w / 2;
    for (var i = 0; i < txt.length; i++) {
      ctx.fillText(txt[i], x, y);
      x += ctx.measureText(txt[i]).width + track * size;
    }
    return size;
  }

  function splitNames(ctx, names, f, size, maxW) {
    var one = names.join(SEP);
    if (textWidth(ctx, one, f, size, 0) <= maxW || names.length < 3) return [one];
    var best = null;
    for (var k = 1; k < names.length; k++) {
      var a = names.slice(0, k).join(SEP), b = names.slice(k).join(SEP);
      var d = Math.abs(textWidth(ctx, a, f, size, 0) - textWidth(ctx, b, f, size, 0));
      if (!best || d < best[0]) best = [d, [a, b]];
    }
    return best[1];
  }

  function page(W, H, bw, bh) {
    bw = bw || 300; bh = bh || 400;
    var s = Math.min(W / bw, H / bh), ox = (W - bw * s) / 2, oy = (H - bh * s) / 2;
    return { s: s, X: function (u) { return ox + u * s; }, Y: function (v) { return oy + v * s; },
             D: function (u) { return u * s; }, F: function (pt) { return pt * PT * s; } };
  }

  /* ---------- ornements ---------- */
  function leaf(ctx, bx, by, dx, dy, L, w) {
    var px = -dy, py = dx;
    function P(a, b) { return [bx + dx * L * a + px * w * b, by + dy * L * a + py * w * b]; }
    var c;
    ctx.beginPath();
    ctx.moveTo(bx, by);
    c = [P(0.20, 0.62), P(0.44, 1.0), P(0.64, 0.80)]; ctx.bezierCurveTo(c[0][0], c[0][1], c[1][0], c[1][1], c[2][0], c[2][1]);
    c = [P(0.82, 0.60), P(0.95, 0.22), P(1.0, 0.0)]; ctx.bezierCurveTo(c[0][0], c[0][1], c[1][0], c[1][1], c[2][0], c[2][1]);
    c = [P(0.95, -0.22), P(0.82, -0.60), P(0.64, -0.80)]; ctx.bezierCurveTo(c[0][0], c[0][1], c[1][0], c[1][1], c[2][0], c[2][1]);
    c = [P(0.44, -1.0), P(0.20, -0.62), [bx, by]]; ctx.bezierCurveTo(c[0][0], c[0][1], c[1][0], c[1][1], c[2][0], c[2][1]);
    ctx.closePath();
    ctx.fill();
  }

  function wreath(ctx, pg, cu, cv, rU, color) {
    var cx = pg.X(cu), cy = pg.Y(cv), r = pg.D(rU), k = rU / 50, pairs = 13, tilt = 30 * Math.PI / 180;
    ctx.save();
    ctx.translate(cx, cy);
    ctx.scale(1, -1);                       // repère mathématique (y vers le haut)
    ctx.fillStyle = color; ctx.strokeStyle = color;
    ctx.lineWidth = pg.F(0.9 * k); ctx.lineCap = 'round';
    [[-84, -248], [-96, 68]].forEach(function (br) {
      var start = br[0], end = br[1], sign = end > start ? 1 : -1, i, a;
      ctx.beginPath();
      for (i = 0; i <= 80; i++) {
        a = (start + (end - start) * i / 80) * Math.PI / 180;
        if (i === 0) ctx.moveTo(r * Math.cos(a), r * Math.sin(a)); else ctx.lineTo(r * Math.cos(a), r * Math.sin(a));
      }
      ctx.stroke();
      for (i = 0; i < pairs; i++) {
        [[1, 0], [-1, 0.5]].forEach(function (so) {
          var side = so[0], f = (i + 0.75 + so[1]) / (pairs + 0.8);
          var ang = (start + (end - start) * f) * Math.PI / 180;
          var bx = r * Math.cos(ang), by = r * Math.sin(ang);
          var nx = Math.cos(ang), ny = Math.sin(ang);
          var tx = -Math.sin(ang) * sign, ty = Math.cos(ang) * sign;
          var L = pg.D((13.0 - 6.0 * f) * k) * (side === 1 ? 1.0 : 0.9);
          var dx = tx * Math.cos(tilt) + side * nx * Math.sin(tilt), dy = ty * Math.cos(tilt) + side * ny * Math.sin(tilt);
          var n = Math.hypot(dx, dy);
          leaf(ctx, bx, by, dx / n, dy / n, L, L * 0.27);
        });
      }
      a = end * Math.PI / 180;
      leaf(ctx, r * Math.cos(a), r * Math.sin(a), -Math.sin(a) * sign, Math.cos(a) * sign, pg.D(7.5 * k), pg.D(2.4 * k));
    });
    ctx.restore();
  }

  function divider(ctx, pg, cu, v, color) {
    var y = pg.Y(v), cx = pg.X(cu), d = pg.D(2.1);
    ctx.strokeStyle = color; ctx.fillStyle = color; ctx.lineWidth = pg.F(0.7);
    ctx.beginPath();
    ctx.moveTo(cx - pg.D(42), y); ctx.lineTo(cx - pg.D(5), y);
    ctx.moveTo(cx + pg.D(5), y); ctx.lineTo(cx + pg.D(42), y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(cx, y - d); ctx.lineTo(cx + d, y); ctx.lineTo(cx, y + d); ctx.lineTo(cx - d, y); ctx.closePath();
    ctx.fill();
  }

  /* ---------- fenêtres photo ---------- */
  function archPath(ctx, l, t, r, b) {
    var rad = (r - l) / 2, cx = (l + r) / 2, cy = t + rad;
    ctx.beginPath();
    ctx.moveTo(l, b); ctx.lineTo(l, cy);
    ctx.arc(cx, cy, rad, Math.PI, 2 * Math.PI);
    ctx.lineTo(r, b); ctx.closePath();
  }

  function windowFor(st) {
    var W = st.fmt.w, H = st.fmt.h, pg;
    switch (st.mode) {
      case 'photo-prenoms':
        if (W > H) {
          pg = page(W, H, 400, 300);
          return { kind: 'arche', l: pg.X(40), t: pg.Y(36), r: pg.X(180), b: pg.Y(264), off: pg.D(5), lw: pg.F(0.8) };
        }
        pg = page(W, H);
        return { kind: 'arche', l: pg.X(62), t: pg.Y(34), r: pg.X(238), b: pg.Y(232), off: pg.D(5), lw: pg.F(0.8) };
      case 'galerie':
        var m = Math.round(0.10 * Math.min(W, H) * 10) / 10, k = Math.min(W, H) / 300;
        return { kind: 'rect', l: m, t: m, r: W - m, b: H - m, off: 4.5 * k, lw: 0.8 * k * PT };
      case 'arche':
        var k2 = Math.min(W, H) / 300;
        return { kind: 'arche', l: 0.15 * W, t: 0.11 * H, r: 0.85 * W, b: 0.89 * H, off: 4.5 * k2, lw: 0.8 * k2 * PT };
      case 'bord':
      case 'libre':
        return { kind: 'rect', l: -BLEED, t: -BLEED, r: W + BLEED, b: H + BLEED, off: 0, lw: 0 };
    }
    return null;
  }

  function photoPlacement(st, win) {
    var img = st.photo, bw = win.r - win.l, bh = win.b - win.t;
    var sc = Math.max(bw / img.width, bh / img.height) * st.zoom;
    var dw = img.width * sc, dh = img.height * sc;
    var mx = (dw - bw) / 2, my = (dh - bh) / 2;
    return { x: win.l + (bw - dw) / 2 + st.px * mx, y: win.t + (bh - dh) / 2 + st.py * my, w: dw, h: dh, mx: mx, my: my };
  }

  function drawWindow(ctx, st, th) {
    var win = windowFor(st);
    if (!win) return;
    ctx.save();
    if (win.kind === 'arche') archPath(ctx, win.l, win.t, win.r, win.b);
    else { ctx.beginPath(); ctx.rect(win.l, win.t, win.r - win.l, win.b - win.t); }
    ctx.clip();
    if (st.photo) {
      var p = photoPlacement(st, win);
      ctx.drawImage(st.photo, p.x, p.y, p.w, p.h);
    } else if (st.mode !== 'libre') {
      ctx.fillStyle = th.ph;
      ctx.fillRect(win.l, win.t, win.r - win.l, win.b - win.t);
    }
    ctx.restore();
    if (!st.photo && st.mode !== 'libre' && st.preview) {
      var k = Math.min(st.fmt.w, st.fmt.h) / 300;
      drawText(ctx, 'AJOUTEZ VOTRE PHOTO', F.sansMd, 13 * PT * k, (win.l + win.r) / 2, (win.t + win.b) / 2, th.accent, 0.42);
    }
    if (win.off) {
      ctx.strokeStyle = th.accent; ctx.lineWidth = win.lw;
      if (win.kind === 'arche') archPath(ctx, win.l - win.off, win.t - win.off, win.r + win.off, win.b + win.off);
      else { ctx.beginPath(); ctx.rect(win.l - win.off, win.t - win.off, win.r - win.l + 2 * win.off, win.b - win.t + 2 * win.off); }
      ctx.stroke();
    }
  }

  /* ---------- textes libres ---------- */
  function luminance(hex) {
    var n = parseInt(String(hex || '#ffffff').slice(1), 16);
    return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  }
  // couleur « auto » : lisible selon le fond (photo, couleur de fond ou papier du coloris)
  function layerColor(st, layer) {
    if (layer.color && layer.color !== 'auto') return layer.color;
    var th = THEMES[st.theme] || THEMES.ivoire;
    if ((st.mode === 'bord' || st.mode === 'libre') && st.photo) return '#FFFFFF';
    if (st.mode === 'libre' || st.mode === 'bord') return luminance(st.bg) > 0.55 ? '#2B2724' : '#F3EEE6';
    return th.ink;
  }

  function layerMetrics(ctx, st, layer) {
    var fs = FONT_STYLES[layer.font] || FONT_STYLES.serif;
    var size = layer.size * Math.min(st.fmt.w, st.fmt.h);
    var lines = String(layer.text || '').split('\n');
    if (fs.upper) lines = lines.map(function (l) { return l.toUpperCase(); });
    var track = fs.track || 0, lh = size * 1.18, w = 0;
    lines.forEach(function (l) { w = Math.max(w, textWidth(ctx, l, fs, size, track)); });
    var h = lh * lines.length;
    var cx = layer.x * st.fmt.w, cy = layer.y * st.fmt.h;
    return { fs: fs, size: size, lines: lines, track: track, lh: lh, w: w, h: h, cx: cx, cy: cy,
             box: { l: cx - w / 2, t: cy - h / 2, r: cx + w / 2, b: cy + h / 2 } };
  }

  function drawLayers(ctx, st) {
    (st.layers || []).forEach(function (layer, idx) {
      if (!layer.text) return;
      var m = layerMetrics(ctx, st, layer);
      m.lines.forEach(function (line, i) {
        var y = m.box.t + m.lh * i + m.size * 0.92;
        drawText(ctx, line, m.fs, m.size, m.cx, y, layerColor(st, layer), m.track);
      });
      if (st.preview && idx === st.selected) {
        ctx.save();
        ctx.setLineDash([1.5, 1.5]);
        ctx.strokeStyle = '#9C7E52';
        ctx.lineWidth = 0.5;
        ctx.strokeRect(m.box.l - 2, m.box.t - 2, m.w + 4, m.h + 4);
        ctx.restore();
      }
    });
  }

  /* ---------- rendu complet ---------- */
  function render(canvas, st, P, bleed) {
    var W = st.fmt.w, H = st.fmt.h;
    var ctx = canvas.getContext('2d');
    var th = THEMES[st.theme] || THEMES.ivoire;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(P, 0, 0, P, bleed * P, bleed * P);
    ctx.fillStyle = st.mode === 'libre' ? (st.bg || th.paper) : th.paper;
    ctx.fillRect(-bleed - 1, -bleed - 1, W + 2 * bleed + 2, H + 2 * bleed + 2);
    var names = (st.names || []).filter(Boolean);
    var land = W > H;
    var pg = land ? page(W, H, 400, 300) : page(W, H);
    var nm = names.length ? names : ['Prénoms'];

    // bloc « La famille / Nom / prénoms » centré en (cu), lignes v[]
    function familyBlock(cu, maxW, L) {
      drawText(ctx, 'LA FAMILLE', F.sansMd, pg.F(L.labelPt), pg.X(cu), pg.Y(L.label), th.ink, 0.5, pg.D(maxW));
      var fam = st.family || 'Nom', spt = L.namePt;
      while (textWidth(ctx, fam, F.serif, pg.F(spt), 0) > pg.D(maxW) && spt > 24) spt -= 0.5;
      drawText(ctx, fam, F.serif, pg.F(spt), pg.X(cu), pg.Y(L.nameC + 0.315 * spt * PT), th.ink);
      divider(ctx, pg, cu, L.div, th.accent);
      var lines = splitNames(ctx, nm, F.serifIt, pg.F(L.firstPt), pg.D(maxW));
      var vs = lines.length === 1 ? [L.first] : [L.first - 4, L.first - 4 + L.firstGap];
      lines.forEach(function (l, i) { drawText(ctx, l, F.serifIt, pg.F(L.firstPt), pg.X(cu), pg.Y(vs[i]), th.ink, 0, pg.D(maxW)); });
      drawText(ctx, L.tag, F.sans, pg.F(L.tagPt), pg.X(cu), pg.Y(L.tagV), th.accent, 0.42, pg.D(maxW));
    }

    if (st.mode === 'laurier') {
      var year = st.year || 'AAAA';
      if (!land) {
        wreath(ctx, pg, 150, 112, 50, th.accent);
        drawText(ctx, 'DEPUIS', F.sansMd, pg.F(13), pg.X(150), pg.Y(98), th.accent, 0.42);
        drawText(ctx, year, F.serifSB, pg.F(82), pg.X(150), pg.Y(126), th.ink, 0, pg.D(66));
        familyBlock(150, 236, { labelPt: 17, label: 200, namePt: 150, nameC: 239.3, div: 275, firstPt: 36, first: 300, firstGap: 16,
                                tag: 'NOTRE PLUS BELLE AVENTURE', tagPt: 12.5, tagV: 339 });
      } else {
        var k = 54 / 50;
        wreath(ctx, pg, 104, 150, 54, th.accent);
        drawText(ctx, 'DEPUIS', F.sansMd, pg.F(13 * k), pg.X(104), pg.Y(150 - 14 * k), th.accent, 0.42);
        drawText(ctx, year, F.serifSB, pg.F(82 * k), pg.X(104), pg.Y(150 + 14 * k), th.ink, 0, pg.D(66 * k));
        familyBlock(268, 180, { labelPt: 15, label: 90, namePt: 120, nameC: 124, div: 156, firstPt: 30, first: 181, firstGap: 16,
                                tag: 'NOTRE PLUS BELLE AVENTURE', tagPt: 11, tagV: 218 });
      }
    } else if (st.mode === 'photo-prenoms') {
      drawWindow(ctx, st, th);
      var tagP = 'DEPUIS ' + (st.year || 'AAAA');
      if (!land) {
        familyBlock(150, 236, { labelPt: 15, label: 262, namePt: 112, nameC: 286.5, div: 316, firstPt: 30, first: 336, firstGap: 14,
                                tag: tagP, tagPt: 12.5, tagV: 368 });
      } else {
        familyBlock(282, 172, { labelPt: 15, label: 92, namePt: 125, nameC: 124, div: 157, firstPt: 29, first: 182, firstGap: 15,
                                tag: tagP, tagPt: 12, tagV: 216 });
      }
    } else {
      drawWindow(ctx, st, th);
      drawLayers(ctx, st);
    }
  }

  function printSize(st) {
    var wIn = (st.fmt.w + 2 * BLEED) / 25.4, hIn = (st.fmt.h + 2 * BLEED) / 25.4;
    var dpi = Math.min(200, Math.floor(Math.sqrt(MAX_PIXELS / (wIn * hIn))));
    return { dpi: dpi, P: dpi / 25.4, w: Math.round(wIn * dpi), h: Math.round(hIn * dpi) };
  }

  function exportPrint(st) {
    return new Promise(function (resolve, reject) {
      var ps = printSize(st);
      var c = document.createElement('canvas');
      c.width = ps.w; c.height = ps.h;
      var printState = Object.assign({}, st, { preview: false });
      render(c, printState, ps.P, BLEED);
      c.toBlob(function (blob) {
        c.width = c.height = 1;
        if (blob) resolve({ blob: blob, dpi: ps.dpi, width: ps.w, height: ps.h }); else reject(new Error('export'));
      }, 'image/jpeg', 0.92);
    });
  }

  /* ---------- formats / coloris depuis les variantes ---------- */
  // « 30×40 cm » + orientation → dimensions en mm (portrait = côté court en largeur)
  function parseFormat(str, orient) {
    var m = /(\d+)\s*[×xX]\s*(\d+)/.exec(str || '');
    var a = 300, b = 400;
    if (m) { a = parseInt(m[1], 10) * 10; b = parseInt(m[2], 10) * 10; }
    var lo = Math.min(a, b), hi = Math.max(a, b);
    return orient === 'paysage' ? { w: hi, h: lo } : { w: lo, h: hi };
  }
  // « Cadre bois naturel » / « Cadre noir » / « Sans cadre » / « Encadré »
  function parseFrame(str) {
    str = (str || '').toLowerCase();
    if (!str || /sans/.test(str) || !/(cadre|encadr)/.test(str)) return '';
    if (/noir/.test(str)) return 'noir';
    if (/blanc/.test(str)) return 'blanc';
    return 'bois';
  }
  function parseTheme(str) {
    str = (str || '').toLowerCase();
    if (str.indexOf('sauge') > -1) return 'sauge';
    if (str.indexOf('nuit') > -1) return 'nuit';
    return 'ivoire';
  }

  /* ---------- interface ---------- */
  var FRAME_MM = 18;   // largeur visible d'une baguette de cadre

  function init(root) {
    var section = root.closest('[data-product-section]') || document;
    var mode = root.dataset.mode;
    var form = document.getElementById(root.dataset.form);
    var previewWrap = section.querySelector('[data-perso-preview]');
    var canvas = previewWrap ? previewWrap.querySelector('canvas') : null;
    var frameEl = previewWrap ? previewWrap.querySelector('[data-perso-frame]') : null;
    var overlay = section.querySelector('[data-perso-overlay]');
    var qualityEl = root.querySelector('[data-perso-quality]');
    var errorEl = root.querySelector('[data-perso-error]');
    if (!canvas || !form) return;
    document.body.classList.add('has-perso');

    var st = {
      mode: mode, theme: 'ivoire', orient: 'portrait', fmt: { w: 300, h: 400 }, frame: '', preview: true,
      family: '', names: [], year: '', photo: null, zoom: 1, px: 0, py: 0,
      bg: THEMES.ivoire.paper, layers: [], selected: -1
    };
    if (mode === 'libre') {
      st.layers = [{ text: 'Votre texte', font: 'script', size: 0.11, color: 'auto', x: 0.5, y: 0.82 }];
      st.selected = 0;
    }

    function face(fam, url, desc) {
      if (!url || typeof FontFace === 'undefined') return Promise.resolve();
      return new FontFace(fam, 'url(' + url + ')', desc).load()
        .then(function (ff) { document.fonts.add(ff); }).catch(function () {});
    }
    var d = root.dataset;
    var fontsReady = Promise.all([
      face('PCormorant', d.fontSerif, { weight: '500' }),
      face('PCormorant', d.fontSerifSb, { weight: '600' }),
      face('PCormorant', d.fontSerifIt, { weight: '500', style: 'italic' }),
      face('PJost', d.fontSans, { weight: '400' }),
      face('PJost', d.fontSansMd, { weight: '500' }),
      face('PScript', d.fontScript, { weight: '400' })
    ]);

    /* aperçu */
    var raf = null;
    function draw() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var cssW = (frameEl && frameEl.parentElement ? frameEl.parentElement.clientWidth : previewWrap.clientWidth) || 480;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var pxW = Math.min(1600, Math.round(cssW * dpr));
        var P = pxW / st.fmt.w;
        canvas.width = pxW;
        canvas.height = Math.round(st.fmt.h * P);
        render(canvas, st, P, 0);
        if (frameEl) {
          frameEl.classList.toggle('is-framed', !!st.frame);
          ['bois', 'noir', 'blanc'].forEach(function (f) { frameEl.classList.toggle('perso-frame--' + f, st.frame === f); });
          frameEl.dataset.orient = st.orient;
          var shown = canvas.getBoundingClientRect().width || cssW;
          frameEl.style.setProperty('--frame-w', Math.max(6, Math.round(shown * FRAME_MM / st.fmt.w)) + 'px');
        }
        updateQuality();
      });
    }

    function updateQuality() {
      if (!qualityEl) return;
      var win = windowFor(st);
      if (!st.photo || !win) { qualityEl.hidden = true; return; }
      var p = photoPlacement(st, win);
      var dpi = st.photo.width / (p.w / 25.4);
      qualityEl.hidden = false;
      if (dpi < 90) { qualityEl.className = 'perso-quality perso-quality--bad'; qualityEl.textContent = 'Photo de faible résolution : le poster risque d’être flou. Choisissez la photo originale, ou un format plus petit.'; }
      else if (dpi < 140) { qualityEl.className = 'perso-quality perso-quality--warn'; qualityEl.textContent = 'Qualité correcte. Pour un rendu parfait, utilisez la photo originale de votre téléphone.'; }
      else { qualityEl.className = 'perso-quality perso-quality--ok'; qualityEl.textContent = 'Excellente qualité d’impression.'; }
    }

    /* petites animations : le cadre se raccroche, la photo se développe */
    var lastLook = '';
    function nudge() {
      if (!frameEl || !document.documentElement.classList.contains('anim')) return;
      frameEl.classList.remove('is-nudge'); void frameEl.offsetWidth; frameEl.classList.add('is-nudge');
    }
    function develop() {
      if (!document.documentElement.classList.contains('anim')) return;
      canvas.classList.remove('is-developing'); void canvas.offsetWidth; canvas.classList.add('is-developing');
    }

    /* variantes (coloris / format / finition) + orientation */
    var orientInput = root.querySelector('[data-perso-orient-input]');
    var orientField = root.querySelector('[data-perso-orient-field]');
    function syncVariant() {
      var fmtStr = '', themeStr = '', frameStr = '';
      section.querySelectorAll('[data-variant-picker] input:checked').forEach(function (input) {
        var fs = input.closest('fieldset'), lg = fs && fs.querySelector('legend');
        var legend = lg ? lg.textContent.toLowerCase() : '';
        if (/format|taille|dimension/.test(legend)) fmtStr = input.value;
        else if (/coloris|couleur|style/.test(legend)) themeStr = input.value;
        else if (/finition|cadre/.test(legend)) frameStr = input.value;
      });
      if (!fmtStr) fmtStr = d.defaultFormat || '';
      // l'orientation peut faire partie de la variante (« 40×30 cm · Paysage ») : elle prime sur le choix séparé
      var orientInVariant = /paysage|portrait/i.test(fmtStr);
      if (orientInVariant) st.orient = /paysage/i.test(fmtStr) ? 'paysage' : 'portrait';
      if (orientField) orientField.hidden = orientInVariant;
      st.fmt = parseFormat(fmtStr, st.orient);
      st.theme = parseTheme(themeStr || d.defaultTheme);
      st.frame = parseFrame(frameStr || fmtStr);
      if (mode === 'libre' && !st.bgTouched) st.bg = THEMES[st.theme].paper;
      if (orientInput) orientInput.value = st.orient === 'paysage' ? 'Paysage' : 'Portrait';
      var look = [st.fmt.w, st.fmt.h, st.theme, st.frame].join('|');
      if (lastLook && look !== lastLook) nudge();
      lastLook = look;
      draw();
    }
    var picker = section.querySelector('[data-variant-picker]');
    if (picker) picker.addEventListener('change', syncVariant);
    root.querySelectorAll('[data-perso-orientation]').forEach(function (r) {
      if (r.checked) st.orient = r.value;
      r.addEventListener('change', function () { if (r.checked) { st.orient = r.value; syncVariant(); } });
    });

    /* champs texte */
    function bindText(sel, fn) {
      var el = root.querySelector(sel);
      if (el) { el.addEventListener('input', function () { fn(el.value); draw(); }); fn(el.value); }
      return el;
    }
    bindText('[data-perso-family]', function (v) { st.family = v.trim(); });
    bindText('[data-perso-year]', function (v) { st.year = v.replace(/[^0-9]/g, '').slice(0, 4); });
    bindText('[data-perso-names]', function (v) {
      st.names = v.split(/[,;\n]+/).map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 8);
    });

    /* photo */
    var photoInput = root.querySelector('[data-perso-photo]');
    var zoomInput = root.querySelector('[data-perso-zoom]');
    var photoTools = root.querySelector('[data-perso-photo-tools]');
    var photoName = root.querySelector('[data-perso-photo-name]');
    function setPhoto(img, name) {
      st.photo = img; st.zoom = 1; st.px = 0; st.py = 0;
      if (zoomInput) zoomInput.value = 1;
      if (photoTools) photoTools.hidden = !img;
      if (photoName) photoName.textContent = name || '';
      root.classList.toggle('has-photo', !!img);
      if (img) develop();
      showError('');
      draw();
    }
    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var file = photoInput.files && photoInput.files[0];
        if (!file) return;
        var img = new Image();
        img.onload = function () { setPhoto(img, file.name); };
        img.onerror = function () { showError('Ce fichier ne peut pas être lu. Choisissez une photo JPG ou PNG.'); };
        img.src = URL.createObjectURL(file);
      });
    }
    if (zoomInput) zoomInput.addEventListener('input', function () { st.zoom = parseFloat(zoomInput.value) || 1; draw(); });
    var removePhotoBtn = root.querySelector('[data-perso-remove-photo]');
    if (removePhotoBtn) removePhotoBtn.addEventListener('click', function () { if (photoInput) photoInput.value = ''; setPhoto(null, ''); });

    /* glisser sur l'aperçu (texte ou photo) */
    var drag = null;
    function toMm(ev) {
      var r = canvas.getBoundingClientRect();
      return { x: (ev.clientX - r.left) / r.width * st.fmt.w, y: (ev.clientY - r.top) / r.height * st.fmt.h };
    }
    canvas.addEventListener('pointerdown', function (ev) {
      var pt = toMm(ev), ctx = canvas.getContext('2d');
      for (var i = st.layers.length - 1; i >= 0; i--) {
        if (!st.layers[i].text) continue;
        var m = layerMetrics(ctx, st, st.layers[i]), pad = 4;
        if (pt.x >= m.box.l - pad && pt.x <= m.box.r + pad && pt.y >= m.box.t - pad && pt.y <= m.box.b + pad) {
          st.selected = i; markSelected();
          drag = { type: 'layer', i: i, sx: pt.x, sy: pt.y, ox: st.layers[i].x, oy: st.layers[i].y };
          break;
        }
      }
      if (!drag && st.photo && windowFor(st)) {
        var p = photoPlacement(st, windowFor(st));
        drag = { type: 'photo', sx: pt.x, sy: pt.y, opx: st.px, opy: st.py, mx: p.mx, my: p.my };
      }
      if (drag) { canvas.setPointerCapture(ev.pointerId); ev.preventDefault(); draw(); }
    });
    canvas.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      var pt = toMm(ev);
      if (drag.type === 'layer') {
        st.layers[drag.i].x = Math.min(0.97, Math.max(0.03, drag.ox + (pt.x - drag.sx) / st.fmt.w));
        st.layers[drag.i].y = Math.min(0.97, Math.max(0.03, drag.oy + (pt.y - drag.sy) / st.fmt.h));
      } else {
        // la photo suit le doigt
        st.px = drag.mx > 0 ? Math.max(-1, Math.min(1, drag.opx + (pt.x - drag.sx) / drag.mx)) : 0;
        st.py = drag.my > 0 ? Math.max(-1, Math.min(1, drag.opy + (pt.y - drag.sy) / drag.my)) : 0;
      }
      draw();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { canvas.addEventListener(t, function () { drag = null; }); });

    /* textes libres (calques) */
    var layerList = root.querySelector('[data-perso-layers]');
    var layerTpl = root.querySelector('[data-perso-layer-template]');
    var addLayerBtn = root.querySelector('[data-perso-add-layer]');
    function markSelected() {
      if (!layerList) return;
      layerList.querySelectorAll('.perso-layer').forEach(function (n, j) { n.classList.toggle('is-selected', j === st.selected); });
    }
    function renderLayerList() {
      if (!layerList || !layerTpl) return;
      layerList.innerHTML = '';
      st.layers.forEach(function (layer, i) {
        var node = layerTpl.content.firstElementChild.cloneNode(true);
        var ta = node.querySelector('[data-l-text]'), fo = node.querySelector('[data-l-font]'),
            sz = node.querySelector('[data-l-size]'), co = node.querySelector('[data-l-color]'),
            rm = node.querySelector('[data-l-remove]');
        ta.value = layer.text; fo.value = layer.font; sz.value = layer.size; co.value = layerColor(st, layer);
        node.addEventListener('focusin', function () { if (st.selected !== i) { st.selected = i; markSelected(); draw(); } });
        ta.addEventListener('input', function () { layer.text = ta.value; draw(); });
        fo.addEventListener('change', function () { layer.font = fo.value; draw(); });
        sz.addEventListener('input', function () { layer.size = parseFloat(sz.value); draw(); });
        co.addEventListener('input', function () { layer.color = co.value; draw(); });
        node.querySelectorAll('[data-l-swatch]').forEach(function (sw) {
          sw.addEventListener('click', function () { layer.color = sw.dataset.lSwatch; co.value = layer.color; draw(); });
        });
        rm.addEventListener('click', function () {
          st.layers.splice(i, 1);
          st.selected = Math.min(st.selected, st.layers.length - 1);
          renderLayerList(); draw();
        });
        layerList.appendChild(node);
      });
      markSelected();
      if (addLayerBtn) addLayerBtn.hidden = st.layers.length >= 6;
    }
    if (addLayerBtn) addLayerBtn.addEventListener('click', function () {
      if (st.layers.length >= 6) return;
      var y = [0.5, 0.2, 0.8, 0.35, 0.65, 0.92][st.layers.length] || 0.5;
      if (mode === 'galerie') y = 1 - 0.05 * Math.min(st.fmt.w, st.fmt.h) / st.fmt.h;   // dans la marge du bas
      if (mode === 'arche') y = 0.945;
      st.layers.push({ text: 'Votre texte', font: mode === 'galerie' || mode === 'arche' ? 'caps' : 'serif',
                       size: mode === 'galerie' || mode === 'arche' ? 0.035 : 0.07,
                       color: 'auto', x: 0.5, y: y });
      st.selected = st.layers.length - 1;
      renderLayerList(); draw();
      var last = layerList && layerList.lastElementChild && layerList.lastElementChild.querySelector('[data-l-text]');
      if (last) { last.focus(); last.select(); }
    });
    root.querySelectorAll('[data-perso-bg]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.bg = b.dataset.persoBg; st.bgTouched = true;
        root.querySelectorAll('[data-perso-bg]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        draw();
      });
    });

    /* validation et envoi */
    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = !msg; } }
    function validate() {
      if (mode === 'laurier' || mode === 'photo-prenoms') {
        if (!st.family) return 'Indiquez votre nom de famille.';
        if (!st.names.length) return 'Indiquez au moins un prénom.';
        if (!/^\d{4}$/.test(st.year)) return 'Indiquez l’année sur 4 chiffres (par exemple 2015).';
      }
      if (['photo-prenoms', 'galerie', 'arche', 'bord'].indexOf(mode) > -1 && !st.photo) return 'Ajoutez votre photo.';
      if (mode === 'libre' && !st.photo && !st.layers.some(function (l) { return l.text; })) return 'Ajoutez une photo ou au moins un texte.';
      return '';
    }

    var printInput = root.querySelector('[data-perso-print]');
    var textsInput = root.querySelector('[data-perso-texts]');
    var configInput = root.querySelector('[data-perso-config]');
    var busy = false;
    function fail() {
      busy = false;
      if (overlay) overlay.hidden = true;
      showError('La préparation du poster a échoué. Réessayez, ou écrivez-nous si le problème persiste.');
    }
    function sendForm(file) {
      form.setAttribute('method', 'post');
      form.setAttribute('enctype', 'multipart/form-data');   // obligatoire pour joindre le fichier
      var attached = false;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        printInput.files = dt.files;
        attached = printInput.files && printInput.files.length === 1;
      } catch (e) { attached = false; }
      if (attached) { HTMLFormElement.prototype.submit.call(form); return; }
      // navigateurs sans DataTransfer : même requête, envoyée en arrière-plan
      var fd = new FormData(form);
      fd.set(printInput.name, file, file.name);
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); window.location.href = d.cartUrl || '/cart'; })
        .catch(fail);
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      var err = validate();
      showError(err);
      if (err) { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      busy = true;
      if (overlay) overlay.hidden = false;
      var tStart = Date.now();
      fontsReady.then(function () { return exportPrint(st); }).then(function (res) {
        var slug = (st.family || mode).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var name = 'poster-' + slug + '-' + st.fmt.w / 10 + 'x' + st.fmt.h / 10 + '.jpg';
        var file = new File([res.blob], name, { type: 'image/jpeg' });
        if (textsInput) {
          textsInput.value = st.layers.map(function (l) { return l.text.replace(/\n/g, ' / '); }).filter(Boolean).join(' | ');
          textsInput.disabled = !textsInput.value;   // pas de ligne vide dans la commande
        }
        if (configInput) configInput.value = JSON.stringify({
          mode: mode, coloris: st.theme, format: st.fmt.w / 10 + 'x' + st.fmt.h / 10 + 'cm', cadre: st.frame || 'sans',
          dpi: res.dpi, px: res.width + 'x' + res.height, fond_perdu_mm: BLEED
        });
        // laisse le message visible un court instant
        setTimeout(function () { sendForm(file); }, Math.max(0, 600 - (Date.now() - tStart)));
      }).catch(fail);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; if (overlay) overlay.hidden = true; } });

    var resizeT = null;
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(draw, 80); });
    renderLayerList();
    syncVariant();
    fontsReady.then(draw);
  }

  function boot() { document.querySelectorAll('[data-personalizer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Accès pour les tests
  window.MaisonPoster = { render: render, exportPrint: exportPrint, printSize: printSize, parseFormat: parseFormat, parseFrame: parseFrame, THEMES: THEMES };
})();
